import React from 'react';
import BaseText from '../typography/BaseText';
import { FONT_SIZE } from '../../../constants/enum';
import '../../../styles/components/blog-card.scss';
import { Link } from 'gatsby';
export default function BlogCards({ title, description, image, uid }) {
  return (
    <Link to={`/blog/${uid}`} className="blog-card-container cursor-pointer">
      <img
        className="rounded blog-img"
        alt={image?.alt ? image?.alt : 'blog-image'}
        width={480}
        height={360}
        src={image?.url}
      />
      <BaseText
        fontSize={FONT_SIZE.PX_22}
        textColor="text-orange-500 hover:text-gray-700 hover:underline"
        fontWeight="text-medium"
        lineHeight="26px"
        className="mb-2 mt-12"
        title={title}
      />
      <BaseText fontSize={FONT_SIZE.PX_16} title={description} />
    </Link>
  );
}
